import Util, { codeProps } from '@/js/common/Util';
import Select, { components } from 'react-select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const { DropdownIndicator } = components;

interface SelectBoxProps {
    name?: string
    onChange?: Function
    onChangeFunc?: Function
    onChangeCodeName?: Function
    codeArray: codeProps[]
    value?: string
    width?: number
    height?: number
    optionHeight?: number
    maxMenuHeight?: number
    placeholder?: string
    textAlign?: "left" | "center" | "right"
    disabled?: boolean
    dsbOptVals?: string[]
    paddingRight?: number
    className?: string
    menuIsOpen?: boolean
    background?: string
    borderColor?: string
    borderOnColor?: string
    borderRadius?: number
    color?: string
    fontSize?: number
    fontFamily?: string
    letterSpacing?: number
    selectedOptionBoxColor?: string
    iconSize?: number
    iconColor?: string
    iconOnColor?: string
}
function SelectBox({
    name,
    onChange,
    onChangeFunc,
    onChangeCodeName,
    codeArray,
    value,
    width,
    height,
    optionHeight,
    maxMenuHeight,
    placeholder,
    textAlign,
    disabled,
    dsbOptVals,
    paddingRight,
    className,
    menuIsOpen,
    background,
    borderOnColor,
    borderColor,
    borderRadius,
    color,
    fontSize,
    fontFamily,
    letterSpacing,
    selectedOptionBoxColor,
    iconSize,
    iconColor,
    iconOnColor
}: SelectBoxProps) {
    const optBoxBgColor = (isDisabled: boolean, isSelected: boolean, isFocused: boolean) => {
        if (isDisabled) {
            return "#E8E8E8";
        }
        if (isSelected) {
            return selectedOptionBoxColor ? selectedOptionBoxColor : "#000";
        }
        if (isFocused) {
            return "#D7D7D7";
        }
    }
    const optBoxFontColor = (isDisabled: boolean, isSelected: boolean, isFocused: boolean) => {
        if (isDisabled) {
            return "#ffffff";
        }
        if (isSelected) {
            return "#ffffff";
        }
        if (isFocused) {
            return "#000000";
        }
    }
    const valueBoxBg = () => {
        let bgStyle;
        if (codeArray && codeArray.length > 0) {
            for (const codeInfo of codeArray) {
                if (value === codeInfo.code) {
                    bgStyle = codeInfo.backgroundUrl;
                }
            }
        }
        return bgStyle;
    }
    const isSearchable = () => {
        let searchPsb = false;
        if (codeArray && codeArray.length > 0) {
            for (const codeInfo of codeArray) {
                if (Util.isNotEmpty(codeInfo.name)) {
                    searchPsb = true;
                    break;
                }
            }
        }
        return searchPsb;
    }
    const isBackgroundImage = () => {
        let imgPsb = false;
        if (codeArray && codeArray.length > 0) {
            for (const codeInfo of codeArray) {
                if (Util.isNotEmpty(codeInfo.backgroundUrl)) {
                    imgPsb = true;
                    break;
                }
            }
        }
        return imgPsb;
    }
    return (
        <Select
            name={name}
            options={codeArray}
            value={Util.isEmpty(value) ? null : codeArray.find((c: codeProps) => c.code === value)}
            onChange={(item: any) => {
                if (onChange !== undefined) {
                    onChange(item.code);
                }
                if (onChangeFunc !== undefined) {
                    onChangeFunc(item.code);
                }
                if (onChangeCodeName !== undefined) {
                    onChangeCodeName(item.code, item.name);
                }
            }}
            getOptionValue={(option) => option.code}
            getOptionLabel={(option) => option.name ? option.name : ""}
            isOptionDisabled={(option: any) => dsbOptVals !== undefined ? dsbOptVals.indexOf(option.code) !== -1 : false}
            placeholder={placeholder || "선택하세요."}
            noOptionsMessage={() => "항목없음"}
            maxMenuHeight={maxMenuHeight ? maxMenuHeight : 200}
            menuPlacement="auto"
            styles={{
                control: (baseStyles, state) => ({
                    background: background ? background : "transparent",
                    border: borderColor ? "1px solid" : "",
                    borderColor: state.isFocused ? borderOnColor : borderColor,
                    ":hover": {
                        borderColor: borderOnColor
                    },
                    borderRadius: borderRadius ? borderRadius : 0,
                    width: !width ? "100%" : width + "px",
                    height: Util.isEmpty(height) ? "100%" : height + "px",
                    display: "flex",
                    textAlign: textAlign,
                    boxSizing: "border-box",
                    paddingLeft: 0,
                    paddingRight: paddingRight,
                    cursor: "pointer",
                    fontSize: fontSize ? fontSize + "px" : "",
                    fontFamily: fontFamily ? fontFamily : "",
                    letterSpacing: letterSpacing ? letterSpacing : 0,
                }),
                singleValue: (baseStyles) => ({
                    ...baseStyles,
                    color: color ? color : "",
                }),
                valueContainer: base => ({
                    ...base,
                    padding: 0,
                    marginTop: (!optionHeight || !height ? 0 : (height - optionHeight) / 2 + "px"),
                    marginBottom: (!optionHeight || !height ? 0 : (height - optionHeight) / 2 + "px"),
                    marginLeft: "8px",
                    marginRight: 0,
                    background: valueBoxBg()
                }),
                noOptionsMessage: base => ({ ...base, fontSize: fontSize + "px", fontFamily: "fm-b", padding: "5px 0" }),
                option: (styles: any, {data, isDisabled, isSelected, isFocused }) => ({
                    ...styles,
                    height: (Util.isEmpty(optionHeight) ? height : optionHeight) + "px",
                    fontSize: fontSize ? fontSize + "px" : "",
                    fontFamily: fontFamily ? fontFamily : "",
                    color: optBoxFontColor(isDisabled, isSelected, isFocused),
                    letterSpacing: letterSpacing ? letterSpacing : 0,
                    display: "flex",
                    justifyContent: textAlign,
                    alignItems: "center",
                    boxSizing: "border-box",
                    backgroundColor: optBoxBgColor(isDisabled, isSelected, isFocused),
                    ":active": {
                        backgroundColor: "#D7D7D7",
                    },
                    background: data.backgroundUrl,
                    borderLeft: isBackgroundImage() ? "8px solid white" : "",
                    borderRight: isBackgroundImage() ? "8px solid white" : "",
                    marginTop: isBackgroundImage() ? "5px" : "",
                    marginBottom: isBackgroundImage() ? "5px" : "",
                    zIndex: 5,
                    cursor: "pointer"
                }),
                input: (base: any) => ({
                    ...base,
                    margin: 0,
                    paddingLeft: 2,
                    'input:focus': {
                        boxShadow: 'none',
                        border: '1px solid #60B3D1'
                    }
                }),
                dropdownIndicator: base => ({
                    ...base,
                    padding: 0
                }),
                menu: base => ({
                    ...base,
                    padding: 0,
                    margin: "3px 0 0 0",
                    zIndex: 2,
                    overflow: "hidden",
                    borderRadius: borderRadius ? borderRadius : 0,
                })
            }}
            className={(className ? className : "")}
            classNamePrefix="select"
            // isMulti
            isDisabled={disabled}
            hideSelectedOptions={false}
            menuIsOpen={menuIsOpen}
            isSearchable={isSearchable()}
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator: props => {
                    const {
                        selectProps: { menuIsOpen }
                    } = props;
                    return (
                        <DropdownIndicator {...props}>
                            {menuIsOpen ?
                                <KeyboardArrowUpIcon sx={{
                                    fontSize: iconSize ? iconSize : 17,
                                    color: iconColor ? iconColor : "#111"
                                }} /> :
                                <KeyboardArrowDownIcon sx={{
                                    fontSize: iconSize ? iconSize : 17,
                                    color: iconOnColor ? iconOnColor : "#111"
                                }} />
                            }
                        </DropdownIndicator>
                    )
                }
            }}
        />
    )
};
export default SelectBox;